<template>
  <div class="grid">
    <template v-if="loader==true">
      <div class="col-12 mb-2 lg:col-12">
        <ProgressBar mode="indeterminate" style="height: .5em" />
      </div>
    </template>

    <!-- ── Selección de empresa (un generador puede tener varias) ── -->
    <div class="col-12" v-if="customers_group.length > 1 && customer_selected == null">
      <div class="mt-search-panel">
        <div class="mt-search-section-label"><i class="pi pi-building"></i> Empresa de transporte</div>
        <div class="mt-search-top">
          <div class="mt-form-field" style="flex:1">
            <label>Seleccione empresa</label>
            <Dropdown v-model="customer_selected" :showClear="true"
              :options="customers_group" optionLabel="name" optionValue="id_customer"
              placeholder="Seleccione una empresa…" @change="cargarTodo" />
          </div>
        </div>
      </div>
    </div>

    <template v-if="customer_selected != null">
      <div class="col-12 flex flex-column header-landing-seway">
        <div class="indicators-container-7">
          <div class="kpi-card kpi-total" @click="selectindicador(0)">
            <div class="kpi-header">
              <span class="kpi-label">TOTAL</span>
              <div class="kpi-icon-wrap kpi-icon-total"><i class="pi pi-chart-bar"></i></div>
            </div>
            <div class="kpi-value">{{ indicadores_viajes.total_deliveries ?? 0 }}</div>
            <div class="kpi-footer"><span class="kpi-badge kpi-badge-neutral">Ver todos</span></div>
          </div>

          <div class="kpi-card kpi-pendiente" @click="selectindicador(1)">
            <div class="kpi-header">
              <span class="kpi-label">PENDIENTES</span>
              <div class="kpi-icon-wrap kpi-icon-pendiente"><i class="pi pi-clock"></i></div>
            </div>
            <div class="kpi-value">{{ indicadores_viajes.total_pendiente ?? 0 }}</div>
            <div class="kpi-footer"><span class="kpi-badge kpi-badge-pendiente">Filtrar</span></div>
          </div>

          <div class="kpi-card kpi-aceptado" @click="selectindicador(2)">
            <div class="kpi-header">
              <span class="kpi-label">ACEPTADOS</span>
              <div class="kpi-icon-wrap kpi-icon-aceptado"><i class="pi pi-check-circle"></i></div>
            </div>
            <div class="kpi-value">{{ indicadores_viajes.total_aceptado ?? 0 }}</div>
            <div class="kpi-footer"><span class="kpi-badge kpi-badge-aceptado">Filtrar</span></div>
          </div>

          <div class="kpi-card kpi-transito" @click="selectindicador(3)">
            <div class="kpi-header">
              <span class="kpi-label">EN TRÁNSITO</span>
              <div class="kpi-icon-wrap kpi-icon-transito"><i class="pi pi-send"></i></div>
            </div>
            <div class="kpi-value">{{ indicadores_viajes.total_transito ?? 0 }}</div>
            <div class="kpi-footer"><span class="kpi-badge kpi-badge-transito">Filtrar</span></div>
          </div>

          <div class="kpi-card kpi-finalizado" @click="selectindicador(4)">
            <div class="kpi-header">
              <span class="kpi-label">FINALIZADO</span>
              <div class="kpi-icon-wrap kpi-icon-finalizado"><i class="pi pi-verified"></i></div>
            </div>
            <div class="kpi-value">{{ indicadores_viajes.total_finalizado ?? 0 }}</div>
            <div class="kpi-footer"><span class="kpi-badge kpi-badge-finalizado">Tasa: {{ tasaExito }}%</span></div>
          </div>

          <div class="kpi-card kpi-rechazado" @click="selectindicador(5)">
            <div class="kpi-header">
              <span class="kpi-label">RECHAZADOS</span>
              <div class="kpi-icon-wrap kpi-icon-rechazado"><i class="pi pi-times-circle"></i></div>
            </div>
            <div class="kpi-value">{{ indicadores_viajes.total_rechazados ?? 0 }}</div>
            <div class="kpi-footer"><span class="kpi-badge kpi-badge-rechazado">Filtrar</span></div>
          </div>

          <div class="kpi-card kpi-anulado" @click="selectindicador(6)">
            <div class="kpi-header">
              <span class="kpi-label">ANULADOS</span>
              <div class="kpi-icon-wrap kpi-icon-anulado"><i class="pi pi-ban"></i></div>
            </div>
            <div class="kpi-value">{{ indicadores_viajes.total_anulados ?? 0 }}</div>
            <div class="kpi-footer"><span class="kpi-badge kpi-badge-anulado">Filtrar</span></div>
          </div>
        </div>
        <div class="last-update">Última actualización: {{ fechaFormateada }}</div>
      </div>

      <div class="field col-12">
        <template v-if="estado_viaje == 10">
          <div class="dashboard-header-movimientos">
            
            <h1><button class="sv-btn-back" @click="customer_selected = null; limpiar()">
                <i class="pi pi-arrow-left"></i>
              </button><i class="pi pi-truck" style="font-size: 2rem"></i> Panel de Viajes</h1>
            <p>Consulta el estado de tus viajes con esta empresa de transporte</p>
          </div>
        </template>

        <template v-else>
          <!-- ── Topbar de estado ── -->
          <div class="sv-topbar">
            <div class="sv-topbar-left">
              <button class="sv-btn-back" @click="estado_viaje = 10; limpiar()">
                <i class="pi pi-arrow-left"></i>
              </button>
              <div>
                <h2 class="sv-title">{{ estado_viaje_descripcion }}</h2>
                <p class="sv-sub">{{ pagination.total ?? 0 }} registros</p>
              </div>
            </div>
            <div class="sv-topbar-right">
              <div v-if="tieneFiltrosActivos" class="sv-filtros-activos">
                <span class="sv-filtros-label"><i class="pi pi-filter-fill"></i> Filtros:</span>
                <span v-if="generadores.length > 1 && frmfiltros.nit_generador" class="sv-chip">
                  {{ nombreGenerador(frmfiltros.nit_generador) }}
                  <i class="pi pi-times" @click="limpiarFiltro('nit_generador')"></i>
                </span>
                <span v-if="frmfiltros.placa" class="sv-chip">
                  {{ frmfiltros.placa }}
                  <i class="pi pi-times" @click="limpiarFiltro('placa')"></i>
                </span>
                <span v-if="frmfiltros.ref_externa" class="sv-chip">
                  Ref: {{ frmfiltros.ref_externa }}
                  <i class="pi pi-times" @click="limpiarFiltro('ref_externa')"></i>
                </span>
                <span v-if="frmfiltros.documento_conductor" class="sv-chip">
                  CC: {{ frmfiltros.documento_conductor }}
                  <i class="pi pi-times" @click="limpiarFiltro('documento_conductor')"></i>
                </span>
                <span v-if="frmfiltros.fechasolicitud && frmfiltros.fechasolicitud.length === 2" class="sv-chip">
                  {{ formatFiltroFecha(frmfiltros.fechasolicitud) }}
                  <i class="pi pi-times" @click="limpiarFiltro('fechasolicitud')"></i>
                </span>
                <button class="sv-chip-clear" @click="limpiar" title="Limpiar todos">
                  <i class="pi pi-times"></i>
                </button>
              </div>
              <button class="sv-btn-outline" @click="toggle">
                <i class="pi pi-filter"></i> Filtrar
              </button>
            </div>
          </div>

          <!-- ── Panel filtros ── -->
          <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" :style="{width:'560px'}">
            <div class="sv-filtros-panel">
              <div class="sv-filtros-title"><i class="pi pi-filter"></i> Filtros de búsqueda</div>
              <div class="sv-filtros-grid">
                <div class="sv-filtros-field" v-if="generadores.length > 1">
                  <label>Generador</label>
                  <Dropdown v-model="frmfiltros.nit_generador" :showClear="true"
                    :options="generadores" optionLabel="nombrecompleto" optionValue="documento"
                    placeholder="Todos los generadores" />
                </div>
                <div class="sv-filtros-field">
                  <label>Placa</label>
                  <InputMask mask="aaa-999" v-model="frmfiltros.placa" placeholder="ABC-123" />
                </div>
                <div class="sv-filtros-field">
                  <label>Referencia externa</label>
                  <InputText v-model="frmfiltros.ref_externa" placeholder="Número de referencia" />
                </div>
                <div class="sv-filtros-field">
                  <label>Cédula del conductor</label>
                  <InputText v-model="frmfiltros.documento_conductor" placeholder="Número de documento" />
                </div>
                <div class="sv-filtros-field sv-filtros-field--full">
                  <label>Rango de fechas</label>
                  <Calendar v-model="frmfiltros.fechasolicitud" selectionMode="range"
                    :showButtonBar="true" :showIcon="true"
                    :locale="$primevue?.config?.locale" placeholder="Seleccione fecha inicio – fin" />
                </div>
              </div>
              <div class="sv-filtros-actions">
                <button class="sv-btn-outline" @click="limpiar">
                  <i class="pi pi-filter-slash"></i> Limpiar
                </button>
                <button class="sv-btn-primary" @click="cargar_detalle(1)">
                  <i class="pi pi-search"></i> Buscar
                </button>
              </div>
            </div>
          </OverlayPanel>

          <!-- ── Tabla ── -->
          <div class="sv-tabla-outer">
            <div class="p-fluid grid">
              <div class="col-12 lg:col-12">
                <DataTable :value="deliveries" :expandedRows="expandedRows"
                  @rowClick="onRowClick" sortMode="multiple"
                  class="tabla-viajes" tableStyle="width: 100%;">
                  <Column expander style="width: 2rem" />
                  <Column field="id_deliverie" header="ID Viaje" sortable>
                    <template #body="slotProps"><strong>{{ slotProps.data.id_deliverie }}</strong></template>
                  </Column>
                  <Column field="movimiento_numero" header="Referencia Externa" sortable>
                    <template #body="slotProps"><strong>{{ slotProps.data.movimiento_numero }}</strong></template>
                  </Column>
                  <Column field="movimiento_operacion" header="Tipo Operación" sortable />
                  <Column field="vehiculo_placa" header="Placa" sortable>
                    <template #body="slotProps"><strong>{{ slotProps.data.vehiculo_placa }}</strong></template>
                  </Column>
                  <Column field="conductor_nombre" header="Conductor" sortable style="width:150px">
                    <template #body="slotProps">
                      {{ toTitleCase(slotProps.data.conductor_nombre) }}<br>
                      <span style="font-size:.78rem;color:#6b7280">CC: {{ slotProps.data.conductor_documento }}</span>
                    </template>
                  </Column>
                  <Column field="movimiento_estado" header="Estado" sortable />
                  <Column field="movimiento_fecha" header="Fecha Movimiento" sortable />
                  <Column field="total_detalle" header="Total Entregas" sortable>
                    <template #body="slotProps"><h3 class="mx-4">{{ slotProps.data.total_detalle }}</h3></template>
                  </Column>
                  <Column field="total_entregado" header="Estados Entregas">
                    <template #body="slotProps">
                      <strong>Pendientes: </strong>{{ slotProps.data.total_pendiente }}<br>
                      <strong>Finalizadas: </strong>{{ slotProps.data.total_entregado }}
                    </template>
                  </Column>

                  <template #expansion="slotProps">
                    <div class="col-12">
                      <div class="col-12 lg:col-12">
                        <TabView @tab-click="(e) => handleRowTabChange(slotProps.data, e)">
                          <TabPanel header="Detalles">
                            <div class="detalle-container-premium">
                              <Accordion :multiple="true" class="detalles-accordion-premium">
                                <AccordionTab v-for="(detalle_mov, index) in (slotProps.data.delivery_details || [])" :key="index">
                                  <template #header>
                                    <div class="accordion-header-premium">
                                      <div class="header-icon"><i class="pi pi-map-marker"></i></div>
                                      <div class="header-content">
                                        <h3 class="detalle-title">Detalle {{ index + 1 }}: {{ toTitleCase(detalle_mov.client_name) }}</h3>
                                        <div class="detalle-subtitle">
                                          <span>{{ toTitleCase(detalle_mov.send_city) }}({{ toTitleCase(detalle_mov.send_country) }}) → {{ toTitleCase(detalle_mov.received_city) }}({{ toTitleCase(detalle_mov.received_country) }})</span>
                                        </div>
                                      </div>
                                    </div>
                                  </template>

                                  <TabView class="detalle-tabs-premium">
                                    <TabPanel header="Detalles">
                                      <div class="cliente-header-premium">
                                        <div class="cliente-titulo">
                                          <span class="label">CLIENTE SOLICITANTE</span>
                                          <strong class="cliente-nombre">{{ toTitleCase(detalle_mov.client_name) }}</strong>
                                        </div>
                                        <div class="cliente-info">
                                          <div>
                                            <span class="info-label">Ubicación</span>
                                            <span class="info-value">{{ toTitleCase(detalle_mov.client_city) }}, {{ toTitleCase(detalle_mov.client_department) }}<template v-if="detalle_mov.client_country"> — {{ toTitleCase(detalle_mov.client_country) }}</template></span>
                                          </div>
                                          <div v-if="detalle_mov.client_address">
                                            <span class="info-label">Dirección</span>
                                            <span class="info-value">{{ toTitleCase(detalle_mov.client_address) }}</span>
                                          </div>
                                          <div><span class="info-label">Email</span><span class="info-value">{{ detalle_mov.client_email }}</span></div>
                                          <div><span class="info-label">Teléfono</span><span class="info-value">{{ detalle_mov.client_phone }}</span></div>
                                          <div v-if="detalle_mov.client_mobile"><span class="info-label">Celular</span><span class="info-value">{{ detalle_mov.client_mobile }}</span></div>
                                        </div>
                                      </div>
                                      <div class="detalle-content-grid">
                                        <Card class="info-card-premium producto">
                                          <template #title><div class="card-title-premium"><i class="pi pi-box"></i><span>PRODUCTO</span></div></template>
                                          <template #content><div class="info-row"><strong>{{ toTitleCase(detalle_mov.product) }}</strong></div></template>
                                        </Card>
                                        <Card class="info-card-premium peso">
                                          <template #title><div class="card-title-premium"><i class="pi pi-chart-bar"></i><span>PESO</span></div></template>
                                          <template #content><div class="metric-display"><div class="metric-value">{{ detalle_mov.weight }}</div><div class="metric-unit">kg</div></div></template>
                                        </Card>
                                        <Card class="info-card-premium unidades">
                                          <template #title><div class="card-title-premium"><i class="pi pi-list"></i><span>UNIDADES</span></div></template>
                                          <template #content><div class="metric-display"><div class="metric-value">{{ detalle_mov.unit }}</div><div class="metric-unit">unidades</div></div></template>
                                        </Card>
                                        <Card class="info-card-premium empaque">
                                          <template #title><div class="card-title-premium"><i class="pi pi-tag"></i><span>EMPAQUE</span></div></template>
                                          <template #content><div class="info-row"><strong>{{ toTitleCase(detalle_mov.packing) }}</strong></div></template>
                                        </Card>
                                      </div>
                                      <div class="route-visual-premium">
                                        <div class="route-point sender">
                                          <div class="point-marker"><i class="pi pi-user"></i></div>
                                          <div class="point-content">
                                            <div class="point-label">REMITENTE</div>
                                            <div class="point-name">{{ toTitleCase(detalle_mov.send_name) }}</div>
                                            <div class="point-address">{{ toTitleCase(detalle_mov.send_address) }}<br>{{ toTitleCase(detalle_mov.send_city) }} ({{ toTitleCase(detalle_mov.send_country) }})</div>
                                            <div class="point-extra">
                                              <div><strong>Tel:</strong> {{ detalle_mov.send_phone }}</div>
                                              <div v-if="detalle_mov.send_mobile"><strong>Celular:</strong> {{ detalle_mov.send_mobile }}</div>
                                              <div v-if="detalle_mov.send_email"><strong>Email:</strong> {{ detalle_mov.send_email }}</div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="route-line"><i class="pi pi-angle-double-right"></i></div>
                                        <div class="route-point receiver">
                                          <div class="point-marker"><i class="pi pi-building"></i></div>
                                          <div class="point-content">
                                            <div class="point-label">DESTINATARIO</div>
                                            <div class="point-name">{{ toTitleCase(detalle_mov.received_name) }}</div>
                                            <div class="point-address">{{ toTitleCase(detalle_mov.received_address) }}<br>{{ toTitleCase(detalle_mov.received_city) }} ({{ toTitleCase(detalle_mov.received_country) }})</div>
                                            <div class="point-extra">
                                              <div><strong>Tel:</strong> {{ detalle_mov.received_phone }}</div>
                                              <div v-if="detalle_mov.received_mobile"><strong>Celular:</strong> {{ detalle_mov.received_mobile }}</div>
                                              <div v-if="detalle_mov.received_email"><strong>Email:</strong> {{ detalle_mov.received_email }}</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </TabPanel>

                                    <TabPanel>
                                      <template #header>Eventos Logísticos ({{ detalle_mov.events?.length || 0 }})</template>
                                      <div v-if="!detalle_mov.events || detalle_mov.events.length===0" class="empty-state-premium">
                                        <h4>No se encontraron eventos logísticos</h4>
                                      </div>
                                      <div v-else class="timeline-horizontal-premium">
                                        <div class="timeline-track">
                                          <div v-for="(evento, eventIndex) in (detalle_mov.events || [])" :key="eventIndex"
                                            class="timeline-event" :class="getEventoClass(evento.id_events)">
                                            <div class="event-circle"><i :class="getEventoIcon(evento.id_events)"></i></div>
                                            <div class="event-card-premium">
                                              <div class="event-title">{{ getEventoLabel(evento.id_events) }}</div>
                                              <div class="event-date">{{ evento.created_at ? formatDate(evento.created_at) : '' }}</div>
                                              <div class="event-actions-premium">
                                                <Button v-if="evento.latitude && evento.longitude" label="VER EN MAPA" icon="pi pi-map-marker"
                                                  class="p-button-sm p-button-outlined" @click="abrirMapa(evento)" />
                                                <Button v-if="evento.image_event && evento.image_event.length > 0"
                                                  :label="`VER IMÁGENES (${evento.image_event.length})`" icon="pi pi-image"
                                                  class="p-button-sm p-button-outlined p-button-warning" :loading="loader_galeria"
                                                  @click="openGaleriaEventos(evento.image_event)" />
                                                <Button v-if="evento.comment" label="VER COMENTARIO" icon="pi pi-comment"
                                                  class="p-button-sm p-button-outlined" @click="toggleComentario($event, evento.comment)" />
                                              </div>
                                            </div>
                                            <div class="event-connector" v-if="eventIndex < (detalle_mov.events.length - 1)"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </TabPanel>
                                  </TabView>
                                </AccordionTab>
                              </Accordion>
                            </div>
                          </TabPanel>

                          <TabPanel header="Resultado PESV">
                            <div v-if="slotProps.data._pesv_cargando" class="col-12 mb-2">
                              <ProgressBar mode="indeterminate" style="height: .5em" />
                            </div>
                            <InspeccionVehicular v-else
                              :inspeccion_vehicular="slotProps.data.inspeccion_vehicular"
                              :fecha_inspeccion="slotProps.data.fecha_inspeccion"
                              :num_movimiento="slotProps.data.movimiento_numero"
                              :id_deliverie="slotProps.data.id_deliverie"
                              :datos_vehiculo="[]"
                              :loader="loader"
                              :IdCustomer="customer_selected" />
                          </TabPanel>
                        </TabView>
                      </div>
                    </div>
                  </template>
                </DataTable>

                <div>
                  <Paginator :rows="pagination.per_page || 15"
                    :rowsPerPageOptions="[15]" :totalRecords="pagination.total || 0"
                    @page="onChangePage($event)" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>

    <!-- ══ Overlay comentario evento ══ -->
    <OverlayPanel ref="opComentario" appendTo="body" :showCloseIcon="true">
      <div class="grid p-fluid"><div class="col-12 lg:col-12"><p>{{ comentario_evento }}</p></div></div>
    </OverlayPanel>

    <!-- ══ Galería de imágenes de eventos ══ -->
    <Galleria :value="img_checklist" :responsiveOptions="galleriaResponsiveOptions" :numVisible="3"
      containerStyle="max-width:50%" :circular="true" :fullScreen="true" :showItemNavigators="true"
      v-model:visible="show_galeria_evnets">
      <template #item="slotProps">
        <img :src="slotProps.item.blob" :alt="slotProps.item.original_url" style="width:60%;display:block;" />
      </template>
    </Galleria>
  </div>
</template>

<script>
import InspeccionVehicular from '../EmpresaTransporte/components/InspeccionVehicular.vue'

export default {
  components: {
    InspeccionVehicular
  },
  data() {
    return {
      loader: false,
      loader_galeria: false,
      customers_group: [],
      customer_selected: null,
      generadores: [],
      deliveries: [],
      expandedRows: [],
      pagination: {},
      indicadores_viajes: {},
      fecha_consulta: null,
      estado_viaje: 10,
      estado_viaje_descripcion: '',
      frmfiltros: {
        placa: '',
        ref_externa: '',
        documento_conductor: '',
        nit_generador: null,
        fechasolicitud: null
      },
      comentario_evento: '',
      img_checklist: [],
      show_galeria_evnets: false,
      galleriaResponsiveOptions: [
        { breakpoint: '724px', numVisible: 5 },
        { breakpoint: '660px', numVisible: 4 },
        { breakpoint: '168px', numVisible: 3 },
        { breakpoint: '160px', numVisible: 1 }
      ]
    }
  },
  computed: {
    tasaExito() {
      const total = this.indicadores_viajes.total_deliveries || 0;
      const finalizado = this.indicadores_viajes.total_finalizado || 0;
      return total > 0 ? Math.round((finalizado / total) * 100) : 0;
    },
    fechaFormateada() {
      return this.fecha_consulta ?? new Date().toLocaleString();
    },
    tieneFiltrosActivos() {
      return !!(this.frmfiltros.placa || this.frmfiltros.ref_externa || this.frmfiltros.documento_conductor || this.frmfiltros.nit_generador ||
        (this.frmfiltros.fechasolicitud && this.frmfiltros.fechasolicitud.length === 2));
    }
  },
  mounted() {
    this.cargarEmpresas();
  },
  methods: {
    cargarEmpresas() {
      const cookieName = 'Email';
      const IdRol = 'IdRol';
      this.loader = true;
      let cookie = {};
      document.cookie.split(';').forEach(function (el) {
        let [key, value] = el.split('=');
        cookie[key.trim()] = value;
      });
      const email = cookie[cookieName];
      const id_rol = cookie[IdRol];
      const _that = this;
      window.api.call('post', '/cargar_customers?&page=1', { email: email, id_rol: id_rol }).then(function (response) {
        if (response.status == 200) {
          _that.customers_group = response.data.data;
          if (response.data.data.length == 1) {
            _that.customer_selected = response.data.data[0].id_customer;
            _that.cargarTodo();
          } else {
            _that.loader = false;
          }
        }
      }).catch(function (err) {
        _that.loader = false;
        console.log(err);
      });
    },
    cargarTodo() {
      if (this.customer_selected == null) return;
      this.estado_viaje = 10;
      this.deliveries = [];
      this.pagination = {};
      this.cargarIndicadores();
    },
    cargarIndicadores() {
      this.loader = true;
      const _that = this;
      window.api.call('post', 'cargar_indicadores_viajes_generador', { id_customer: this.customer_selected }).then(function (response) {
        if (response.status == 200) {
          _that.indicadores_viajes = response.data.indicadores_viajes;
          _that.generadores = response.data.generadores;
          _that.fecha_consulta = new Date().toLocaleString();
          _that.loader = false;
        }
      }).catch(function (err) {
        _that.loader = false;
        console.log(err);
      });
    },
    nombreGenerador(documento) {
      const g = this.generadores.find(x => x.documento === documento);
      return g ? g.nombrecompleto : documento;
    },
    selectindicador(n) {
      const descripciones = {
        0: 'Todos los viajes', 1: 'Viajes Pendientes', 2: 'Viajes Aceptados',
        3: 'Viajes en Tránsito', 4: 'Viajes Finalizados', 5: 'Viajes Rechazados', 6: 'Viajes Anulados'
      };
      this.estado_viaje = n;
      this.estado_viaje_descripcion = descripciones[n] ?? 'Viajes';
      this.limpiar();
      this.cargar_detalle(1);
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    limpiar() {
      this.frmfiltros = { placa: '', ref_externa: '', documento_conductor: '', nit_generador: null, fechasolicitud: null };
    },
    limpiarFiltro(campo) {
      if (campo === 'fechasolicitud') { this.frmfiltros.fechasolicitud = null; }
      else if (campo === 'nit_generador') { this.frmfiltros.nit_generador = null; }
      else { this.frmfiltros[campo] = ''; }
      this.cargar_detalle(1);
    },
    formatFiltroFecha(rango) {
      if (!rango || rango.length < 2 || !rango[0] || !rango[1]) return '';
      const f = (d) => new Date(d).toLocaleDateString();
      return f(rango[0]) + ' – ' + f(rango[1]);
    },
    cargar_detalle(page) {
      if (this.customer_selected == null) {
        this.$toast.add({ severity: 'error', summary: 'Selecciona una empresa de transporte', detail: '', life: 4000 });
        return;
      }
      this.loader = true;
      const _that = this;
      let placa = this.frmfiltros.placa ? this.frmfiltros.placa.replaceAll('-', '') : '';
      let fecha = null, fecha_fin = null, rango = false;
      if (this.frmfiltros.fechasolicitud && this.frmfiltros.fechasolicitud.length > 0) {
        fecha = this.frmfiltros.fechasolicitud[0];
        if (this.frmfiltros.fechasolicitud.length === 2 && this.frmfiltros.fechasolicitud[1]) {
          fecha_fin = this.frmfiltros.fechasolicitud[1];
          rango = true;
        }
      }
      const payload = {
        id_customer: this.customer_selected,
        placa: placa,
        ref_externa: this.frmfiltros.ref_externa,
        documento_conductor: this.frmfiltros.documento_conductor,
        nit_generador: this.frmfiltros.nit_generador,
        fecha: fecha,
        fecha_fin: fecha_fin,
        rango: rango,
        estado_viaje: this.estado_viaje
      };
      window.api.call('post', 'cargar_mov_transporte_consolidado?&page=' + page, payload).then(function (response) {
        if (response.status == 200) {
          _that.deliveries = response.data.data.data;
          _that.pagination = response.data.data;
          _that.generadores = response.data.generadores;
          _that.expandedRows = [];
          _that.loader = false;
        }
      }).catch(function (err) {
        _that.loader = false;
        console.log(err);
      });
    },
    onChangePage(event) {
      this.cargar_detalle(event.page + 1);
    },
    onRowClick(event) {
      // delivery_details ya viene incluido en la respuesta de cargar_mov_transporte_consolidado,
      // aquí solo se controla la expansión/colapso de la fila.
      const row = event.data;
      const idx = this.expandedRows.indexOf(row);
      if (idx !== -1) {
        this.expandedRows.splice(idx, 1);
      } else {
        this.expandedRows.push(row);
      }
    },
    handleRowTabChange(row, event) {
      if (event.index === 1 && !row._pesv_cargado) {
        this.fetchPesv(row);
      }
    },
    fetchPesv(row) {
      row._pesv_cargando = true;
      const _that = this;
      window.api.call('post', 'traerchecklist', { id_customer: this.customer_selected, id_deliverie: row.id_deliverie }).then(function (response) {
        row._pesv_cargando = false;
        row._pesv_cargado = true;
        if (response.status == 200) {
          row.inspeccion_vehicular = response.data.inspeccion_vehicular;
          row.fecha_inspeccion = response.data.inspeccion_vehicular?.checklist_general_date ?? null;
        }
      }).catch(function (err) {
        row._pesv_cargando = false;
        row._pesv_cargado = true;
        console.log(err);
      });
    },
    abrirMapa(evento) {
      window.open('https://www.google.com.co/maps?q=' + evento.latitude + ',' + evento.longitude, '_blank');
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const match = String(dateString).match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
      if (!match) return '';
      const [, year, month, day, hour, minute, second] = match;
      // Se construye con componentes locales (sin pasar por Date.parse/UTC) para que
      // la hora mostrada sea siempre la misma que llega en el string, sin corrimientos
      // por la zona horaria del navegador.
      const date = new Date(+year, +month - 1, +day, +hour, +minute, +(second || 0));
      return date.toLocaleString('es-CO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    },
    toggleComentario(event, comentario) {
      this.comentario_evento = comentario;
      this.$refs.opComentario.toggle(event);
    },
    openGaleriaEventos(images) {
      this.img_checklist = [];
      this.loader_galeria = true;
      const _that = this;
      window.api.call('post', 'img_public', { imagenes: images, nombre_campo_img: 'image_url' }).then(function (response) {
        _that.loader_galeria = false;
        if (response.status == 200) {
          _that.img_checklist = response.data.data.images;
          _that.show_galeria_evnets = true;
        }
      }).catch(function (err) {
        _that.loader_galeria = false;
        console.log(err);
      });
    },
    getEventoLabel(id) {
      const labels = {
        2: 'Llegada de Carga', 3: 'Inicio de Carga', 4: 'Fin de Carga',
        5: 'Carga aceptada', 6: 'Llegada a sitio Descargue', 7: 'Inicio Descargue',
        8: 'Fin Descargue', 9: 'Descarga Aceptada', 10: 'Entrega Pendiente',
        11: 'Entrega Exitosa', 12: 'Entrega Rechazada', 13: 'Planta de carga reservada',
        14: 'Inicio de carga en planta', 15: 'Fin de carga en planta',
        16: 'Inicio de descarga en planta', 17: 'Fin de descarga en planta',
        18: 'Descargada en planta no reservada'
      };
      return labels[id] ?? 'Evento ' + id;
    },
    getEventoClass(id) {
      const exitosos = [5, 9, 11]; const pendientes = [10]; const rechazados = [12];
      if (exitosos.includes(id)) return 'exitoso';
      if (rechazados.includes(id)) return 'rechazado';
      if (pendientes.includes(id)) return 'pendiente';
      return 'llegada';
    },
    getEventoIcon(id) {
      const icons = {
        2: 'pi-truck', 3: 'pi-box', 4: 'pi-box', 5: 'pi-check-circle',
        6: 'pi-building', 7: 'pi-download', 8: 'pi-check', 9: 'pi-truck',
        10: 'pi-exclamation-triangle', 11: 'pi-verified', 12: 'pi-times-circle',
        13: 'pi-map-marker', 14: 'pi-building', 15: 'pi-building',
        16: 'pi-building', 17: 'pi-building', 18: 'pi-map-marker'
      };
      return 'pi ' + (icons[id] ?? 'pi-circle');
    },
    toTitleCase(str) {
      if (!str) return '';
      return String(str).toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
    }
  }
}
</script>

<style scoped lang="scss">
$navy:#0A354E; $orange:#EB7D10; $white:#fff;
$g200:#e8eaed; $g500:#6b7280; $g700:#374151; $r:16px; $bg:#f7f7f7;

/* ── Selección de empresa (reutiliza patrón de MovTransporte.vue) ── */
.mt-search-panel { background:$white; border:1px solid $g200; border-radius:$r; padding:1.25rem 1.5rem; margin-bottom:1.25rem; }
.mt-search-section-label { display:flex; align-items:center; gap:.4rem; font-size:.72rem; font-weight:700; color:$navy; text-transform:uppercase; letter-spacing:.5px; padding-bottom:.6rem; border-bottom:1px solid $g200; margin-bottom:.875rem; i{font-size:12px;} }
.mt-search-top { display:flex; align-items:flex-end; gap:.75rem; flex-wrap:wrap; }
.mt-form-field { display:flex; flex-direction:column; gap:.3rem; label{font-size:.72rem;font-weight:700;color:$g500;text-transform:uppercase;letter-spacing:.5px;} }

/* ── KPI ── */
.header-landing-seway{}
.indicators-container-7 {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 0.875rem;
    width: 100%;
    margin-bottom: 1.5rem;
}
.kpi-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 1rem 1.1rem 0.875rem;
    border: 1.5px solid #e5e7eb;
    cursor: pointer;
    transition: transform 0.18s ease, box-shadow 0.18s ease;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    min-width: 0;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.09);
    }
}
.kpi-header { display: flex; align-items: center; justify-content: space-between; gap: 0.25rem; }
.kpi-label { font-size: 0.65rem; font-weight: 700; letter-spacing: 0.6px; color: #6b7280; text-transform: uppercase; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.kpi-icon-wrap { width: 30px; height: 30px; border-radius: 8px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; i { font-size: 0.9rem; } }
.kpi-value { font-size: 1.85rem; font-weight: 800; color: #111827; line-height: 1.1; display: flex; align-items: center; gap: 0.25rem; }
.kpi-footer { display: flex; align-items: center; margin-top: 0.1rem; }
.kpi-badge { font-size: 0.68rem; font-weight: 600; padding: 0.2rem 0.6rem; border-radius: 20px; white-space: nowrap; }

.kpi-total         { border-color: #bfdbfe; }
.kpi-icon-total    { background: #dbeafe; i { color: #2563eb; } }
.kpi-badge-neutral { background: #dbeafe; color: #1d4ed8; }

.kpi-pendiente         { border-color: #fde68a; }
.kpi-icon-pendiente    { background: #fef3c7; i { color: #d97706; } }
.kpi-badge-pendiente   { background: #fef3c7; color: #92400e; }

.kpi-aceptado          { border-color: #6ee7b7; }
.kpi-icon-aceptado     { background: #d1fae5; i { color: #059669; } }
.kpi-badge-aceptado    { background: #d1fae5; color: #065f46; }

.kpi-transito          { border-color: #93c5fd; }
.kpi-icon-transito     { background: #dbeafe; i { color: #2563eb; } }
.kpi-badge-transito    { background: #dbeafe; color: #1d4ed8; }

.kpi-finalizado        { border-color: #6ee7b7; }
.kpi-icon-finalizado   { background: #d1fae5; i { color: #059669; } }
.kpi-badge-finalizado  { background: #d1fae5; color: #065f46; }

.kpi-rechazado         { border-color: #fca5a5; }
.kpi-icon-rechazado    { background: #fee2e2; i { color: #dc2626; } }
.kpi-badge-rechazado   { background: #fee2e2; color: #991b1b; }

.kpi-anulado           { border-color: #d1d5db; }
.kpi-icon-anulado      { background: #f3f4f6; i { color: #6b7280; } }
.kpi-badge-anulado     { background: #f3f4f6; color: #374151; }

@media (max-width: 1200px) { .indicators-container-7 { grid-template-columns: repeat(4, 1fr); } }
@media (max-width: 700px)  { .indicators-container-7 { grid-template-columns: repeat(2, 1fr); } }

.last-update { text-align: right; font-size: 0.85rem; color: #6b7280; }

.dashboard-header-movimientos { padding: 1rem 0; h1{font-weight:700;color:$g700;display:flex;align-items:center;gap:.5rem;} p{color:$g500;} }

/* ── Topbar / filtros / tabla (mismo lenguaje visual que viajesSeway.vue) ── */
.sv-topbar { display:flex; justify-content:space-between; align-items:center; margin-bottom:1rem; flex-wrap:wrap; gap:.75rem; background:$white; border:1px solid $g200; border-radius:$r; padding:.875rem 1.25rem; }
.sv-topbar-left  { display:flex; align-items:center; gap:.75rem; flex:1; }
.sv-topbar-right { display:flex; align-items:center; gap:.65rem; flex-wrap:wrap; }
.sv-title  { font-size:1.25rem; font-weight:700; color:$g700; margin:0 0 .15rem; }
.sv-sub    { font-size:.78rem; color:$g500; margin:0; }

.sv-btn-back { display:inline-flex; align-items:center; justify-content:center; width:34px; height:34px; background:$white; border:1px solid $g200; border-radius:8px; cursor:pointer; color:$g700; transition:all .15s; flex-shrink:0; &:hover{border-color:$navy;color:$navy;} }
.sv-btn-primary { display:inline-flex; align-items:center; gap:.35rem; background:$navy; color:#fff; border:none; border-radius:8px; padding:.45rem 1rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:background .15s; i{font-size:13px;} &:hover{background:#0c4f77;} &:disabled{opacity:.6;cursor:not-allowed;} }
.sv-btn-outline  { display:inline-flex; align-items:center; gap:.35rem; background:$white; color:$g700; border:1px solid $g200; border-radius:8px; padding:.45rem .9rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:all .15s; i{font-size:13px;} &:hover{border-color:$navy;color:$navy;} }

.sv-tabla-outer { background:$white; border:1px solid $g200; border-radius:$r; overflow:hidden; padding:.5rem 0 0; }

.sv-filtros-activos { display:flex; align-items:center; gap:.4rem; flex-wrap:wrap; padding:.4rem .75rem; background:#eef2ff; border:1px solid #c7d2fe; border-radius:8px; }
.sv-filtros-label   { display:flex; align-items:center; gap:.3rem; font-size:.72rem; font-weight:700; color:$navy; text-transform:uppercase; letter-spacing:.5px; white-space:nowrap; i{font-size:.75rem;} }
.sv-chip { display:inline-flex; align-items:center; gap:.3rem; background:$white; border:1px solid #a5b4fc; color:$g700; padding:.2rem .6rem; border-radius:20px; font-size:.78rem; font-weight:600; i{font-size:.65rem;color:$g500;cursor:pointer; &:hover{color:#ef4444;}} }
.sv-chip-clear { width:22px; height:22px; background:#fee2e2; border:1px solid #fecaca; border-radius:50%; cursor:pointer; display:inline-flex; align-items:center; justify-content:center; margin-left:.25rem; i{font-size:.65rem;color:#ef4444;} &:hover{background:#ef4444; i{color:$white;}} }

.sv-filtros-panel { padding:.25rem; }
.sv-filtros-title  { display:flex; align-items:center; gap:.5rem; font-size:.9rem; font-weight:700; color:$navy; padding-bottom:.75rem; border-bottom:1px solid $g200; margin-bottom:.875rem; i{font-size:14px;} }
.sv-filtros-grid   { display:grid; grid-template-columns:repeat(2,1fr); gap:.75rem; margin-bottom:1rem; }
.sv-filtros-field  { display:flex; flex-direction:column; gap:.3rem; label{font-size:.72rem;font-weight:700;color:$g500;text-transform:uppercase;letter-spacing:.5px;} }
.sv-filtros-field--full { grid-column:1/-1; }
.sv-filtros-actions { display:flex; justify-content:flex-end; gap:.65rem; padding-top:.75rem; border-top:1px solid $g200; }

.tabla-viajes{ font-size: 0.9rem; }

/* ── Detalle / accordion / eventos (idéntico a viajesSeway.vue) ── */
.detalle-container-premium { padding: 0; }

.cliente-header-premium { width: 100%; border: 1px solid #e5e7eb; border-radius: 8px; padding: 16px 20px; margin-bottom: 16px; background: #fff; }
.cliente-titulo { display: flex; flex-direction: column; gap: 4px; margin-bottom: 12px; .label { font-size: 11px; color: #6b7280; font-weight: 600; letter-spacing: .5px; } }
.cliente-nombre { font-size: 14px; font-weight: 700; color: #111827; }
.cliente-info { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 12px; }
.info-label { display: block; font-size: 11px; color: #6b7280; font-weight: 600; }
.info-value { font-size: 13px; color: #111827; }

:deep(.detalles-accordion-premium) {
  .p-accordion-header-link { padding: 0; border: none; background: transparent; }
  .p-accordion-tab { border: 1px solid #e2e8f0; border-radius: 12px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.05); margin: 0.5rem 0; }
  .p-accordion-content { padding: 0; border: none; }
}

.accordion-header-premium {
  display: flex; align-items: center; gap: 1rem; padding: 1.25rem 1.5rem; width: 100%;
  .header-icon { width: 48px; height: 48px; border-radius: 12px; background: linear-gradient(135deg, #0d496b 0%, #0A354E 100%); display: flex; align-items: center; justify-content: center; color: white; font-size: 1.25rem; flex-shrink: 0; }
  .header-content {
    flex: 1;
    .detalle-title { font-size: 1.125rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem 0; }
    .detalle-subtitle { font-size: 0.875rem; color: #64748b; }
  }
}

:deep(.detalle-tabs-premium) {
  .p-tabview-nav { background: #f8fafb; border: none; border-bottom: 2px solid #e2e8f0; padding: 0; }
  .p-tabview-nav-link { border: none; background: transparent; color: #64748b; font-weight: 600; font-size: 0.9375rem; padding: 1rem 1.5rem; &:hover { background: transparent; color: #1e293b; } }
  .p-highlight .p-tabview-nav-link { color: #1a5f7a; border-bottom: 3px solid #1a5f7a; }
  .p-tabview-panels { background: #ffffff; }
}

.detalle-content-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 2rem; }

.info-card-premium {
  border-radius: 10px; border: 1px solid #e2e8f0; box-shadow: 0 1px 3px rgba(0,0,0,0.05); transition: all 0.2s;
  &:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.08); }
  :deep(.p-card-title) { padding: 0.875rem 1rem; margin: 0; border-bottom: 1px solid #e2e8f0; }
  :deep(.p-card-content) { padding: 1rem; }
  &.producto :deep(.p-card-title) { background: #dbeafe; }
  &.peso :deep(.p-card-title) { background: #d1fae5; }
  &.unidades :deep(.p-card-title) { background: #fef3c7; }
  &.empaque :deep(.p-card-title) { background: #f3e8ff; }
}

.card-title-premium { display: flex; align-items: center; gap: 0.5rem; font-size: 0.75rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; color: #1e293b; i { font-size: 1rem; } }
.info-row { display: flex; flex-direction: column; gap: 0.25rem; font-size: 0.875rem; margin-bottom: 0.75rem; &:last-child { margin-bottom: 0; } }
.metric-display { display: flex; align-items: baseline; gap: 0.5rem; .metric-value { font-size: 2rem; font-weight: 700; color: #1e293b; line-height: 1; } .metric-unit { font-size: 0.875rem; color: #64748b; font-weight: 500; } }

.route-visual-premium { display: flex; align-items: center; gap: 2rem; padding: 1.5rem; background: #f8fafb; border-radius: 10px; border: 1px solid #e2e8f0; margin-bottom: 1.5rem; }
.route-point {
  flex: 1; display: flex; gap: 1rem;
  &.sender .point-marker { background: linear-gradient(135deg, #10b981, #059669); }
  &.receiver .point-marker { background: linear-gradient(135deg, #ef4444, #dc2626); }
}
.point-marker { width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center; color: white; font-size: 1.25rem; flex-shrink: 0; }
.point-content { flex: 1; }
.point-label { font-size: 0.75rem; font-weight: 700; text-transform: uppercase; color: #64748b; letter-spacing: 0.5px; margin-bottom: 0.25rem; }
.point-name { font-size: 1rem; font-weight: 700; color: #1e293b; margin-bottom: 0.5rem; }
.point-extra { color: #64748b; }
.point-address { font-size: 0.875rem; color: #64748b; line-height: 1.5; }
.route-line { flex-shrink: 0; display: flex; align-items: center; font-size: 1.5rem; color: #94a3b8; }

.timeline-horizontal-premium { position: relative; width: 100%; padding: 2rem 1rem; overflow: hidden; }
.timeline-track {
  display: flex; align-items: stretch; gap: 2rem; overflow-x: auto; overflow-y: hidden; padding: 0 1rem 1rem 1rem;
  flex-direction: row; flex-wrap: nowrap; scroll-behavior: smooth;
  &::-webkit-scrollbar { height: 8px; }
  &::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 10px; }
  &::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; &:hover { background: #94a3b8; } }
}
.timeline-event {
  display: flex; flex-direction: column; align-items: center; position: relative; min-width: 100px; max-width: 280px; flex-shrink: 0;
  &.llegada .event-circle { background: linear-gradient(135deg, #2e7eff, #4b84ff); }
  &.exitoso .event-circle { background: linear-gradient(135deg, #36c094, #36c094); }
  &.rechazado .event-circle { background: linear-gradient(135deg, #ef4444, #dc2626); }
  &.pendiente .event-circle { background: linear-gradient(135deg, #f59e0b, #d97706); }
}
.event-circle { width: 64px; height: 64px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; font-size: 1.75rem; box-shadow: 0 4px 12px rgba(0,0,0,0.15); margin-bottom: 1rem; z-index: 2; }
.event-card-premium {
  background: white; border: 1px solid #e2e8f0; border-radius: 10px; padding: 1.25rem; text-align: center; box-shadow: 0 2px 8px rgba(0,0,0,0.06); transition: all 0.2s;
  &:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
}
.event-title { font-size: 0.875rem; font-weight: 700; color: #1e293b; margin-bottom: 0.5rem; text-transform: uppercase; letter-spacing: 0.3px; }
.event-date { font-size: 0.8125rem; color: #64748b; margin-bottom: 1rem; padding: 0.375rem 0.75rem; background: #f8fafb; border-radius: 6px; }
.event-actions-premium { display: flex; flex-direction: column; gap: 0.5rem; :deep(.p-button) { font-size: 0.75rem; padding: 0.5rem 0.75rem; text-transform: uppercase; letter-spacing: 0.3px; font-weight: 600; } }
.event-connector { position: absolute; top: 32px; left: 100%; width: 2rem; height: 2px; background: linear-gradient(90deg, #cbd5e1, #e2e8f0); }

.empty-state-premium { text-align: center; padding: 4rem 2rem; h4 { font-size: 1.125rem; font-weight: 600; color: #64748b; } }
</style>
